import React, { useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { userShortFIOFormatter } from '../../utils/formatters';
import { getClientPersonalData } from '../../modules/Authorized/reducer';
import UpdatePeriodSelector from './UpdatePeriodSelector';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';
import MobileLayoutLegend from './MobileLayoutLegend';
import Menu from './Menu';
import MobileLayoutSubMenu from './MobileLayoutSubMenu';

export default function MobileMiniProfile(props) {
  const {
    onHide = () => {}, lowVisionMode, setLowVisionMode, currentRoutesByMenu,
  } = props;
  const [showLegend, setShowLegend] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const profile = useSelector(getClientPersonalData);
  const defaultAvatar = `${process.env.PUBLIC_URL}/img/default-avatar.svg`;
  return ReactDOM.createPortal(
    (
      <div className="mobile-mini-profile">
        <div className="mobile-profile-bg" />
        <div className="mobile-profile-content">
          <div className="mobile-profile-header">
            <div className="mobile-profile-user">
              <div className="mini-profile-image">
                <img
                  className="mini-profile-avatar"
                  src={defaultAvatar}
                  alt="A"
                  onError={e => {
                    e.target.src = defaultAvatar;
                  }}
                />
              </div>
              <div className="mini-profile-text">
                <div className="mp-name">{userShortFIOFormatter(profile)}</div>
                {/* <div className="mp-profession">{userProfile}</div> */}
              </div>
              <div className="mini-profile-close" onClick={onHide}>
                <Icons icon="close" customIcon />
              </div>
            </div>
            <div className="mobile-profile-buttons">
              <UpdatePeriodSelector />
              <div
                className={classNames('glasses-block', { active: lowVisionMode })}
                onClick={() => setLowVisionMode(!lowVisionMode)}
              >
                <Icons
                  customIcon
                  className="glasses-icon"
                  icon="glasses"
                />
              </div>
              <div className="help-block" onClick={() => setShowLegend(!showLegend)}>
                <Icons customIcon className="help-icon" icon="help" />
              </div>
              <div
                className="arrow-close"
                onClick={() => setShowSubMenu(!showSubMenu)}
              >
                <Icons
                  customIcon
                  className="glasses-icon"
                  icon="arrow-down-2"
                />
              </div>
            </div>

          </div>
          <div className="mobile-profile-content-wrapper custom-scroll-theme">
            {showLegend ? <MobileLayoutLegend onHide={() => setShowLegend(false)} /> : null}
            {showSubMenu ? <MobileLayoutSubMenu onHide={() => setShowSubMenu(false)} /> : null}
            <Menu currentRoutesByMenu={currentRoutesByMenu} defOpen />
          </div>
        </div>
      </div>
    ), document.body,
  );
}
